<div style="display: flex; flex-direction: column; justify-content: center; align-items: center; background: white; width:100%; height: 100%; padding-top: 20px;">
    <h2>No feature access</h2>
    <br>
    <p>Contact admin if you require access to this feature</p>
</div>
